import React from "react";
import styled from "@emotion/styled";
import { ClearedStyleRouterLink } from "@modules/Components";
import { IoIosArrowBack } from "react-icons/io";
import SellFlowItem from "./SellFlowItem";
import PreloadLink from "@components/PreloadLink";

const FlowStatus = styled.div`
  width: 100%;
  display: grid;
  grid-template-columns: auto auto auto;
  text-align: left;
  justify-content: center;
  grid-gap: 55px;

  @media (max-width: 1400px) {
    grid-gap: 35px;
  }
  @media (max-width: 999px) {
    margin-left: 20px !important;
    margin-right: 0px !important;
    justify-content: flex-start;
    grid-gap: 20px;
  }
  @media (max-width: 575px) {
    grid-template-columns: auto auto auto auto;
    margin-left: 0 !important;
  }
  @media (max-width: 475px) {
    grid-template-columns: 1fr auto auto auto 1fr;
  }
  @media (max-width: 315px) {
    margin-left: 5px !important;
    grid-gap: 10px;
  }
`;

const GridItem = styled.div`
  @media (min-width: 476px) {
    display: none;
  }
`;

const BackToCart = styled.div`
  @media (min-width: 576px) {
    display: none;
  }

  font-size: 14px;
  font-weight: bold;
  cursor: pointer;
  justify-self: flex-end;
  display: flex;
  padding-right: 30px;

  @media (max-width: 475px) {
    padding-right: 0px;
    justify-self: flex-start;
  }
  @media (max-width: 410px) {
    padding-right: 28px;
  }
  @media (max-width: 350px) {
    padding-right: 8px;
  }
`;

const RouterLink = styled(ClearedStyleRouterLink)`
  color: #777984;
  display: flex;
  justify-content: center;
  align-items: center;
`;

const BackArrow = styled(IoIosArrowBack)`
  cursor: pointer;
  color: inherit;
  font-size: 17px;
  margin-right: 6px;
`;

const flow = [
  {
    id: 1,
    text: "Get Quote",
    link: "/sell-gift-cards/"
  },
  {
    id: 2,
    text: "Submit Cards",
    link: "/step-two/"
  },
  {
    id: 3,
    text: "Get Paid 💰",
    tabletText: "Complete order",
    link: "/payout/"
  }
];
const SellFlowStatus = () => {
  return (
    <FlowStatus>
      <BackToCart>
        <PreloadLink page={"StepTwoSell"}>
          <RouterLink to="/step-two/">
            <BackArrow />
            Back
          </RouterLink>
        </PreloadLink>
      </BackToCart>
      {flow.map((item, index) => (
        <SellFlowItem key={index} item={item} />
      ))}
      <GridItem />
    </FlowStatus>
  );
};

export default SellFlowStatus;
